__turbopack_context__.v({
  "dropAuctionContainer": "retailers-module-scss-module__ZyoGTW__dropAuctionContainer",
  "listDropSection": "retailers-module-scss-module__ZyoGTW__listDropSection",
  "listDropSectionContent": "retailers-module-scss-module__ZyoGTW__listDropSectionContent",
  "topContainer": "retailers-module-scss-module__ZyoGTW__topContainer",
  "topContainerImageContainer": "retailers-module-scss-module__ZyoGTW__topContainerImageContainer",
  "topContainer__Image": "retailers-module-scss-module__ZyoGTW__topContainer__Image",
  "topContainer__Right": "retailers-module-scss-module__ZyoGTW__topContainer__Right",
  "topContainer__RightInner": "retailers-module-scss-module__ZyoGTW__topContainer__RightInner",
});
